import { env } from '../config/env';

/** Target API whose JWT `aud` must match the access token. */
export type ApiAudience = 'sms' | 'tariffs' | 'cdp' | 'tracker' | 'auth';

/** Menu modules — same ids as `ModuleId` / nav audiences. */
export type MenuAudience = Exclude<ApiAudience, 'auth'>;

const STORAGE_PREFIX = 'botto_admin_access_';

export function accessStorageKey(audience: ApiAudience): string {
  return `${STORAGE_PREFIX}${audience}`;
}

/** Registered auth application name (= JWT aud) for each backend. */
export function audienceAppName(audience: ApiAudience): string {
  return env.apiAuthApps[audience];
}

export const API_AUDIENCES: ApiAudience[] = ['sms', 'tariffs', 'cdp', 'tracker', 'auth'];

/** Fetched at login — all nav module audiences. */
export const LOGIN_AUDIENCES: ApiAudience[] = ['sms', 'tariffs', 'cdp', 'tracker'];

/** Side-nav modules (hide section when JWT has no permissions for that aud). */
export const MENU_AUDIENCES: MenuAudience[] = ['sms', 'tariffs', 'cdp', 'tracker'];

/** Exchanged lazily on first API call to the corresponding backend. */
export const LAZY_AUDIENCES: ApiAudience[] = ['auth'];
